import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import {
  GeolocationControl,
  Map,
  YMaps,
  YMapsApi,
  ZoomControl,
} from "react-yandex-maps";
import { toastAlert } from "src/components/common/SnackbarAlert/toastAlert";
import { AddressPlacemarkState } from "src/components/ReservationProduct/ReservationProduct";

export interface YandexMapProp {
  coords?: [number, number];
  setYmapsApi: (ymaps: YMapsApi) => void;
  addressPlacemark?: AddressPlacemarkState | null;
  minHeight?: string;
}

const YandexMap: React.FC<YandexMapProp> = ({
  coords,
  setYmapsApi,
  children,
  addressPlacemark,
  minHeight,
}) => {
  const [isError, setIsError] = useState(false);
  const getGeoLocation = (ymaps: YMapsApi) => {
    return ymaps.geolocation
      .get({ provider: "yandex", mapStateAutoApply: true })
      .then((result: any) =>
        ymaps
          .geocode(result.geoObjects.position)
          .then((res: any) => res.geoObjects.get(0).geometry.getCoordinates())
      );
  };

  const errorsHandler = () => {
    toastAlert("Карта временно не доступна", "error");
    setIsError(true);
  };

  const handleApiAvailable = (ymaps: YMapsApi) => {
    setYmapsApi(ymaps);
    getGeoLocation(ymaps);
  };

  return !isError ? (
    <Paper elevation={10}>
      <YMaps
        query={{
          apikey: process.env.MAP_API_KEY,
        }}
      >
        {coords && (
          <Map
            onIdle={(event: any) => console.log(event)}
            style={{ minHeight: minHeight ? minHeight : "calc(100vh - 72px)" }}
            onLoad={(ymaps: YMapsApi) => handleApiAvailable(ymaps)}
            onError={errorsHandler}
            state={{
              center: coords,
              zoom: addressPlacemark ? 16 : 11,
            }}
            modules={[
              "templateLayoutFactory",
              "layout.ImageWithContent",
              "layout.templateBased.Base",
              "geolocation",
              "geocode",
              "geoObject.addon.balloon",
              "geoObject.addon.hint",
            ]}
            options={{ suppressMapOpenBlock: true }}
          >
            <ZoomControl options={{ float: "right" }} />
            <GeolocationControl
              options={{ float: "right" }}
              data={{
                content: "Где я?",
              }}
            />
            {children}
          </Map>
        )}
      </YMaps>
    </Paper>
  ) : null;
};

export default YandexMap;
